var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M1.53,16A1.51,1.51,0,0,1,0,14.506V6.7H16v7.808A1.51,1.51,0,0,1,14.47,16ZM0,5.954V2.611A1.51,1.51,0,0,1,1.53,1.116h1.9V2.709a1.1,1.1,0,0,0-.375.826,1.143,1.143,0,0,0,2.286,0A1.106,1.106,0,0,0,4.953,2.7V1.116h6.1V2.7a1.1,1.1,0,0,0-.382.832,1.143,1.143,0,0,0,2.286,0,1.1,1.1,0,0,0-.381-.832V1.116H14.47A1.51,1.51,0,0,1,16,2.611V5.954ZM11.435,3.535V.372a.381.381,0,0,1,.762,0V3.535a.381.381,0,0,1-.762,0Zm-7.619,0V.372a.381.381,0,0,1,.762,0V3.535a.381.381,0,0,1-.762,0Z",
    fill: "rgba(207,207,207,0.95)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a6475fb0236d14689aa79a3a9bffe8fb.svg";
export { ForwardRef as ReactComponent };